import * as actions from './actions';
import * as reducer from './reducer';
import * as selectors from './selectors';

// Using default export for compatibility
export default { actions, reducer, selectors };
